<script lang="ts">
  import EditableText from './EditableText.svelte';
  import Provenance from './Provenance.svelte';
  import type { BlockText, RenderCtx } from './types';

  let { block, ctx, editing = false, onchange }: {
    block: BlockText;
    ctx: RenderCtx;
    editing?: boolean;
    onchange?: (next: BlockText) => void;
  } = $props();
</script>

<p class="brf-p">{#if block.lead}<b>{block.lead}</b> {/if}<EditableText
    value={block.body.text} {editing} ariaLabel={block.lead || 'Paragraph'}
    onchange={(text) => onchange?.({ ...block, body: { ...block.body, text } })} /><Provenance
    provenance={block.body.provenance} sourceIds={block.body.source_ids} {ctx} /></p>
